// Versionamento do client para auto-update: o build gera public/version.json
// (via scripts/gen-version.mjs no prebuild) e o client o envia no handshake
// do websocket. Se o servidor estiver servindo outra versao, ele responde com
// {type:'refresh'} e o client recarrega, pegando os assets novos.
//
// CLIENT_PROTOCOL eh o versionamento do PROTOCOLO ws, separado da versao de
// assets: deploy de backend (gateway/ws-server) nao muda os assets, entao nao
// pode forcar refresh sozinho. Quando o formato dos pacotes mudar de forma
// incompativel, suba CLIENT_PROTOCOL aqui E PROTOCOL_VERSION no server.js na
// MESMA ordem: primeiro o frontend (client passa a enviar o campo, servidor
// antigo ignora), depois o ws-server (passa a exigir). Sempre que o protocolo
// mudar, os dois lados sao dependentes por natureza.

export const CLIENT_PROTOCOL = 1;

let cachedVersion: string | null | undefined;
let cachedWorkerVersion: string | null | undefined;

function getVersionJsonUrl(): string {
  // Web Workers resolve URLs relativos ao script do worker, nao a pagina.
  // O worker fica em assets/, entao ../version.json aponta para a raiz do app.
  const base =
    typeof window === 'undefined'
      ? self.location.href
      : window.location.href;
  const path = typeof window === 'undefined' ? '../version.json' : 'version.json';
  return new URL(path, base).href + `?_cb=${Date.now()}`;
}

export async function getClientVersion(): Promise<string | null> {
  if (cachedVersion !== undefined) return cachedVersion;
  await loadVersionJson();
  return cachedVersion ?? null;
}

export async function getClientWorkerVersion(): Promise<string | null> {
  if (cachedWorkerVersion !== undefined) return cachedWorkerVersion;
  await loadVersionJson();
  return cachedWorkerVersion ?? null;
}

async function loadVersionJson(): Promise<void> {
  if (cachedVersion !== undefined && cachedWorkerVersion !== undefined) return;
  try {
    const res = await fetch(getVersionJsonUrl(), { cache: 'no-store' });
    if (!res.ok) {
      cachedVersion = null;
      cachedWorkerVersion = null;
      return;
    }
    const data = await res.json();
    cachedVersion = typeof data.version === 'string' ? data.version : null;
    cachedWorkerVersion = typeof data.workerVersion === 'string' ? data.workerVersion : null;
  } catch {
    cachedVersion = null;
    cachedWorkerVersion = null;
  }
}

const RELOAD_GUARD_KEY = 'stream-activity-last-refresh';
const RELOAD_GUARD_MS = 60000;

export function handleRefreshMessage(expected?: string): void {
  try {
    if (new URLSearchParams(window.location.search).has('noversioncheck')) {
      console.warn('[version] refresh ignorado por ?noversioncheck');
      return;
    }
  } catch {
    /* ignora */
  }
  const now = Date.now();
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) || 0);
  } catch {
    /* sessionStorage indisponivel: sem guarda */
  }
  if (now - last < RELOAD_GUARD_MS) {
    console.warn('[version] refresh solicitado de novo em menos de 60s, ignorando para evitar loop', expected);
    return;
  }
  try {
    sessionStorage.setItem(RELOAD_GUARD_KEY, String(now));
  } catch {
    /* ignora */
  }
  console.log('[version] versao desatualizada (esperada:', expected, '), recarregando...');
  setTimeout(() => location.reload(), 500);
}
